import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { toast } from 'react-toastify';
import { auth, getAllAreas, getAllPlants, logout } from '../../api/firebase';
import PlantAreas from './dashboard/plant-area/PlantAreas';
import Plants from './dashboard/plants/Plants';
import Footer from './Footer';
import Header from './Header';

const Home = () => {
  const [isLoggedin, setLoggedin] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [selectedArea, setSelectedArea] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const [fetchedAreas, setFetchedAreas] = useState([]);
  const [fetchedPlants, setFetchedplants] = useState([]);

  const fetchAreas = async () => {
    const receivedAreas = [];
    setLoading(true);
    try {
      const receivedAreasSnapShot = await getAllAreas();
      receivedAreasSnapShot.forEach((d) => {
        const doc = d.data();
        receivedAreas.push({
          id: d.id,
          name: doc.name,
          description: doc.description,
          isDeleted: doc.isDeleted,
        });
      });
      setFetchedAreas(receivedAreas);
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    setLoading(false);
  };

  const fetchPlants = async (areaId) => {
    const plants = [];
    setLoading(true);
    try {
      const receivedPlantsSnapShot = await getAllPlants(areaId);
      receivedPlantsSnapShot.forEach((d) => {
        const doc = d.data();
        plants.push({
          id: d.id,
          name: doc.name,
          description: doc.description,
          scientificName: doc.scientificName,
          images: doc.images,
          isArchived: doc.isArchived,
        });
      });
      setFetchedplants(plants);
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    setLoading(false);
  };

  const logoutUser = async () => {
    setLoading(true);
    try {
      await logout();
    } catch (e) {
      toast.error(e.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    setLoading(false);
  };

  const handleShowPlants = async (area) => {
    setSelectedArea(area);
    await fetchPlants(area.id);
  };

  const handlebackFromPlants = async () => {
    setSelectedArea(null);
    setFetchedplants([]);
    await fetchAreas();
  };

  useEffect(() => {
    fetchAreas();
  }, []);

  useEffect(() => {
    if (user) setLoggedin(true);
    else setLoggedin(false);
  }, [user]);

  return (
    <section className="text-gray-600 body-font">
      <div className="container px-5 lg:px-16 py-20 mx-auto">
        <Header isLoggedin={isLoggedin} area={selectedArea} />
        {!selectedArea ? (
          <PlantAreas
            isLoading={isLoading || loading}
            setLoading={setLoading}
            isLoggedin={isLoggedin}
            fetchedAreas={fetchedAreas}
            fetchAreas={fetchAreas}
            showPlants={handleShowPlants}
          />
        ) : (
          <Plants
            isLoading={isLoading}
            setLoading={setLoading}
            isLoggedin={isLoggedin}
            fetchedPlants={fetchedPlants}
            fetchPlants={fetchPlants}
            area={selectedArea}
            areaList={fetchedAreas}
          />
        )}
        <Footer
          isLoading={isLoading || loading}
          isLoggedin={isLoggedin}
          logoutUser={logoutUser}
          showPlants={selectedArea}
          goBack={handlebackFromPlants}
        />
      </div>
    </section>
  );
};

export default Home;
